import { Component, OnInit, Input } from '@angular/core';

import { Endereco } from "./../shared/endereco.model";
import { EstadoApiService } from "../estados/shared/estado-api.service";
import { CidadeApiService } from "../cidades/shared/cidade-api.service";
import { TipoLogradouroApiService } from "../tipos-logradouro/shared/tipo-logradouro-api.service";
import { EnderecoService } from "../shared/endereco.service";
import { UtilService } from "../../../shared/services/util.service";
import { ProjetoService } from "../../../projeto/shared/projeto.service";
import { DataService } from "../../../core/services/data.service";

@Component({
    selector: 'app-endereco-form',
    template: require('./endereco-form.component.html'),
    styles: [require('./endereco-form.component.css')]
})
export class EnderecoFormComponent implements OnInit {
    @Input() formObject: any = new Endereco();

    tipoLogradourosList: any[] = [];
    estadosList: any[] = [];
    cidadesList: any[] = [];
    loadingCidade: boolean = false;
    loadingEstado: boolean = true;
    loadingTipoLogradouro: boolean = true;

    private project: any = {};

    constructor(
        private _estadoApiService: EstadoApiService,
        private _cidadeApiService: CidadeApiService,
        private _enderecoService: EnderecoService,
        private _tipoLogradouroApiService: TipoLogradouroApiService,
        private _projetoService: ProjetoService,
        private _utilService: UtilService,
        private _dataService: DataService
    ) { }

    ngOnInit() {
        this.project = this._projetoService.getSessionStorage();
        this.getEstados();
        this.getTiposLogradouro();

        this.initialize();
    }

    initialize() {
        let lat: any, lng: any;
        if (this.formObject.coordenadaLatitude && this.formObject.coordenadaLongitude) {
            lat = this.formObject.coordenadaLatitude;
            lng = this.formObject.coordenadaLongitude;
        } else {
            if (this.project) {
                lat = this.project.latitude;
                lng = this.project.longitude;
            } else {
                let coord: any = this._dataService.getCoordinates();
                lat =  coord.lat;
                lng = coord.lng;
            }
        }
        this._enderecoService.initMap(lat, lng);
    }

    changeEstado() {
        this.getCidades();
    }

    getGeocoding() {
        var onDone = (function(response: any) {
            if (response) {
                this.formObject.coordenadaLatitude = this._utilService.cloneObject(response.lat);
                this.formObject.coordenadaLongitude = this._utilService.cloneObject(response.lng);

                let y: any = document.getElementById("coordenadaLatitude");
                if (y) {
                    y.value = response.lat;
                }

                y = document.getElementById("coordenadaLongitude");
                if (y) {
                    y.value = response.lng;
                }
            }
        }.bind(this));

        let f = this._enderecoService.getGeocodingAddress(this.formObject);
        this._enderecoService.getGeocoding(f, onDone);
    }

    private getEstados() {
        var onDone = (function (Response: any) {
            if (!Response.error)  {
                this.estadosList = Response;

                if (this.formObject.id) {
                    if (this.formObject.cidade && this.formObject.cidade.estado) {
                        this.setEstado(this.formObject.cidade.estado.id);
                    }
                } else {
                    if (this.project) {
                        this.setEstado(this.project.estadoId);
                    } else {
                        this.setEstado(this.estadosList[11].id);
                    }
                }

                this.loadingEstado = false;
                this.getCidades();
            }
        }.bind(this));

        this._estadoApiService.onGetAll(onDone);
    }

    private getCidades() {
        var onDone = (function (Response: any) {
            if (!Response.error)  {
                this.cidadesList = Response;

                if (this.formObject.id) {
                    if (this.formObject.cidade) {
                        this.setCidade(this.formObject.cidade.id);
                    }
                } else {
                    if (this.project) {
                        this.setCidade(this.project.cidadeId);
                    } else {
                        this.setCidade(this.cidadesList[0].id);
                    }
                }

                this.loadingCidade = false;
            }
        }.bind(this));

        var estado: any = this.formObject.estado;
        if (estado) {
            this.loadingCidade = true;
            this._cidadeApiService.onGetByEstado(estado.id, onDone);
        }
    }

    private getTiposLogradouro() {
        var onDone = (function (Response: any) {
            if (!Response.error)  {
                this.tipoLogradourosList = Response;

                if (this.formObject.id) {
                    var x: any, lenX: any;
                    for (x = 0, lenX = this.tipoLogradourosList.length; x < lenX; x++) {
                        if (this.tipoLogradourosList[x].id === this.formObject.tipoLogradouroId) {
                            this.formObject.tipoLogradouro = this.tipoLogradourosList[x];
                            break;
                        }
                    }
                } else {
                    this.formObject.tipoLogradouro = this.tipoLogradourosList[0];
                }

                this.loadingTipoLogradouro = false;
            }
        }.bind(this));

        this._tipoLogradouroApiService.onGetAll(onDone);
    }

    private setEstado(estadoId: number) {
        let x: any, lenX: any;
        for (x = 0, lenX = this.estadosList.length; x < lenX; x++) {
            if (this.estadosList[x].id === estadoId) {
                this.formObject.estado = this.estadosList[x];
                break;
            }
        }
    }

    private setCidade(cidadeId: number) {
        let x: any, lenX: any;
        for (x = 0, lenX = this.cidadesList.length; x < lenX; x++) {
            if (this.cidadesList[x].id === cidadeId) {
                this.formObject.cidade = this.cidadesList[x];
                break;
            }
        }
    }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/estruturas/enderecos/endereco-form/endereco-form.component.ts
 **/